import React from 'react';
import styled from 'styled-components';
import {
  primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div<{ marginTop: string }>`
  text-align: center;
  width: 100%;
  margin-top: ${(props) => props.marginTop};
  .heading {
    font-family: ${secondaryFont};
    font-size: 24px;
    font-weight: ${wMBold};
    color: ${primaryHeadingColor};
    margin-bottom: 20px;
    &.two {
      margin-bottom: 10px;
    }
  }
  .para {
    font-family: ${secondaryFont};
    font-size: 18px;
    font-weight: ${wMBold};
    color: ${primaryHeadingColor};
    margin-bottom: 10px;
  }
`;

type Props = {
  marginTop?: string,
} & typeof defaultProps;

const defaultProps = {
  marginTop: '100px',
};

const SearchNoResultFoundWidget = function SearchNoResultFoundWidget(props: Props) {
  const { marginTop } = props;
  return (
    <Wrapper marginTop={marginTop}>
      <h6 className="heading">No results found!</h6>
      <h6 className="heading two">Try adjusting your search to find:</h6>
      <p className="para">1. People by their First Name, Last Name, and Company Name, e.g. Tim Cook Apple</p>
      <p className="para two">2. Accounts by their Name, or Website, or Ticker Symbol, e.g. Apple</p>
    </Wrapper>
  );
};

SearchNoResultFoundWidget.defaultProps = defaultProps;
export default SearchNoResultFoundWidget;
